/**
 * Пометка «авто» — черновик рождён расписанием бренда (автоновость пн/ср/пт, автодайджест в
 * пятницу), а не нажатием «Запустить генерацию». Релиз 2026-10-14, решение Ильи 4.
 *
 * ЭТО НЕ СТАТУС. Статус такого черновика — обычный «ожидает» (`pending_review`), и пилюля
 * статуса рядом говорит именно его. Пометка отвечает на другой вопрос — «откуда пост», —
 * поэтому у неё своя форма: контур без заливки. Залитые пилюли base.css заняты статусами
 * (§2.1 ui-design), а пунктирная `.st-new` — архивом; заимствовать любую значило бы
 * сказать «авто» цветом какого-то статуса.
 *
 * Один компонент на бэклог и шапку черновика — подпись и подсказка не могут разойтись.
 */

import type { JSX } from 'react';
import styles from './AutoBadge.module.css';

export const AUTO_BADGE_TEXT = 'авто';
export const AUTO_BADGE_TITLE = 'создан автоматически по расписанию';

export function AutoBadge(): JSX.Element {
  return (
    <span className={`pill ${styles['auto']}`} title={AUTO_BADGE_TITLE}>
      {AUTO_BADGE_TEXT}
    </span>
  );
}
